/**
 * Cards #718 and #701: the calculation a Calculation field was given in Settings.
 *
 * A field created in Settings keeps its real formula on the field itself. A field created from a
 * product keeps only a placeholder there ("Start with Quantity"); the real recipe is that
 * product's own copy. The item form used to read only a product's own copy or another product's,
 * so a product with neither opened "Edit calculation" on the placeholder (#718) and its "Calculate
 * on quotes" switch saved with no recipe, which the server stores as off (#701).
 */

/** The placeholder the server writes on a field created from a product (createDefaultFormula). */
export function isPlaceholderFormula(formula: any): boolean {
  const steps = Array.isArray(formula?.steps) ? formula.steps : [];
  return steps.length === 1 && steps[0]?.type === 'source' && steps[0]?.value === 'Item.Quantity';
}

/**
 * The field's own formula as this product's starting copy: parsed, deep-copied, or null when the
 * field has none, it is unreadable, has no steps, or is only the placeholder.
 */
export function fieldOwnFormula(field: any): any {
  let formula = field?.formula_json;
  if (typeof formula === 'string') {
    try {
      formula = JSON.parse(formula);
    } catch {
      return null; // unreadable: treated as "no formula", the builder starts as before
    }
  }
  if (!formula || typeof formula !== 'object' || Array.isArray(formula)) return null;
  if (!Array.isArray(formula.steps) || formula.steps.length === 0) return null;
  if (isPlaceholderFormula(formula)) return null;
  return JSON.parse(JSON.stringify(formula));
}
